enum FundingSourceCode {
  DEALER_COST = 'DEALER_COST',
  DEALER_PROFIT = 'DEALER_PROFIT',
  ASC_DEALER_PROFIT = 'ASC_DEALER_PROFIT',
}

export default FundingSourceCode;
export type VerifyFundingSourceCode = Utils.VerifyExtends<
  Model.Enum.FundingSourceCode,
  Utils.ValueOf<typeof FundingSourceCode>
>;
